import angular from 'angular';
import 'angular-bootstrap';
import 'leaflet';
import 'leaflet-draw';
import locales from '../../locale';

import './groupsServices';
import 'Leaflet.Snap';
import '../../../scripts/leaflet-label-shim';

const groupsControllers = angular.module('applicationModule.groupsControllers', [
    'applicationModule.groupsServices',
    'commonModule.localizationMapService',
    'ui.bootstrap'
]);

// Groups List Controller
groupsControllers.controller('GroupsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'Group', 'growl', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, NgTableParams, Group, growl, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('groups');
    $scope.application_id = $stateParams.application_id;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;

            return Group.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.groups.total);
                    params.count(response.groups.per_page);
                    params.page(response.groups.current_page);

                    return response.groups.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeGroup = function (id, index) {
        Group.remove(id, $scope.application_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.GROUPS.SUCCESS.DELETE_GROUP');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.GROUPS.ERROR.DELETE');
                }
            });
    };

    $scope.searchGroups = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);

}]);

// Group Page Controller
groupsControllers.controller('GroupController', ['$scope', '$rootScope', '$stateParams', '$state', 'Group', 'growl', 'Permissions', function ($scope, $rootScope, $stateParams, $state, Group, growl, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('groups');
    $scope.application_id = $stateParams.application_id;

    $scope.editMode = false;
    $scope.group = {};

    if (angular.isDefined($stateParams.groupId)) {
        $scope.editMode = true;
        $rootScope.doingResolve = true;

        const groupId = $stateParams.groupId;

        Group.get(groupId, $scope.application_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.group = data.group[0];
                } else {
                    growl.error('MODULES.GROUPS.' + data.error);
                }
            })
            .catch(function () {
                $state.go('appsoup.application.groups', {application_id: $scope.application_id}, growl.error('ERROR.EMPTY_DATA'));
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.group.app_id = $scope.application_id;
        $scope.isLoading = true;
        Group.save($scope.group, $scope.editMode)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.GROUPS.SUCCESS.' + ($scope.editMode ? 'GROUP_EDITED' : 'GROUP_CREATED'));
                    $state.go('appsoup.application.groups', {application_id: $scope.application_id});
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.GROUPS.ERROR.' + ($scope.editMode ? 'GROUP_EDITED' : 'GROUP_CREATED'));
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.groups', {application_id: $scope.application_id});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.GROUPS.ERROR.REQUIRE.NAME'}]
    };

}]);

// Users List Page Controller
groupsControllers.controller('GroupListController', ['$scope', '$rootScope', '$stateParams', 'AppsoupAPI', 'AppUsers', 'NgTableParams', '$state', 'Group', 'Permissions', function ($scope, $rootScope, $stateParams, AppsoupAPI, AppUsers, NgTableParams, $state, Group, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('groups');
    $scope.application_id = $stateParams.application_id;
    const groupId = $stateParams.groupId;
    $scope.tableParams = new NgTableParams(AppsoupAPI.getEmailTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Group.usersList($scope.application_id, groupId, params._params)
                .then(function (response) {
                    if (response.success) {
                        const users = response.users;
                        params.total(users.total);
                        params.count(users.per_page);
                        params.page(users.current_page);
                        return users.data;
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

}]);

export default groupsControllers;
